import React, { lazy, Suspense } from 'react';
import { ShieldCheck, PlayCircle, Info } from 'lucide-react';
import { scrollToId } from '../MarketingHeader';

const WorkspaceMockup = lazy(() => import('./WorkspaceMockup'));

export const Hero = ({ onAuth }) => (
  <section className="mk-hero" aria-labelledby="hero-title">
    <div className="mk-container mk-hero-grid">
      <div className="mk-hero-copy mk-rise">
        <p className="mk-eyebrow">AI-assisted research for stock and options traders</p>
        <h1 id="hero-title" data-testid="hero-headline">See the data behind every AI signal.</h1>
        <p className="mk-hero-sub">
          AI-assisted research for stock and options traders: signals with the drivers, key levels and risks shown, so you can judge them yourself.
        </p>
        <div className="mk-hero-ctas">
          <button type="button" className="mk-btn mk-btn-primary mk-btn-lg" onClick={() => onAuth('signup')} data-testid="hero-trial-cta">Start Free Trial</button>
          <a className="mk-btn mk-btn-ghost mk-btn-lg" href="#workspace" onClick={(e) => { if (scrollToId('workspace')) e.preventDefault(); }} data-testid="hero-demo-cta">
            <PlayCircle size={18} aria-hidden="true" /> View Product Demo
          </a>
        </div>
        <p className="mk-trust-note"><ShieldCheck size={16} aria-hidden="true" /> For research and educational purposes only. Not investment advice.</p>
      </div>
      <div className="mk-hero-visual mk-rise mk-delay-1">
        <p className="mk-illustrative" data-testid="hero-illustrative-label"><Info size={14} aria-hidden="true" /> Illustrative example, not a real signal.</p>
        <Suspense fallback={<div className="mk-mock mk-skel" aria-hidden="true" />}>
          <WorkspaceMockup />
        </Suspense>
      </div>
    </div>
  </section>
);
